"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ClassList = {
  _nativeClassList: function _nativeClassList(element) {
    return element.classList;
  },
  _fakeClassList: function _fakeClassList(element) {
    return element.className.split(/\s+/).filter(function (v) {
      return !!v;
    });
  },
  _list: function _list(element) {
    if ('classList' in element) {
      this._list = this._nativeClassList;
    } else {
      this._list = this._fakeClassList;
    }

    return this._list(element);
  },
  _indexOf: function _indexOf(list, value) {
    if (list.indexOf) return list.indexOf(value);

    for (var i = 0; i < list.length; i++) {
      if (list[i] == value) return i;
    }

    return -1;
  },
  has: function has(element, className) {
    if (!element) return false;

    var L = this._list(element);

    return this._indexOf(L, className) != -1;
  },
  add: function add(element) {
    if (!element) return;
    var L = [].slice.call(this._list(element));

    for (var _len = arguments.length, cnl = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      cnl[_key - 1] = arguments[_key];
    }

    cnl.forEach(function (name) {
      if (this._indexOf(L, name) == -1) L.push(name);
    }, this);
    element.className = L.join(' ');
  },
  remove: function remove(element) {
    if (!element) return;
    var L = [].slice.call(this._list(element));

    for (var _len2 = arguments.length, cnl = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      cnl[_key2 - 1] = arguments[_key2];
    }

    cnl.forEach(function (name) {
      var p = this._indexOf(L, name);

      if (p != -1) L.splice(p, 1);
    }, this);
    element.className = L.join(' ');
  },
  toggle: function toggle(element) {
    var _this = this;

    for (var _len3 = arguments.length, cnl = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      cnl[_key3 - 1] = arguments[_key3];
    }

    cnl.forEach(function (name) {
      if (_this.has(element, name)) _this.remove(element, name);else _this.add(element, name);
    });
  },
  join: function join() {
    for (var _len4 = arguments.length, list = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      list[_key4] = arguments[_key4];
    }

    var cnl = list.map(function (item) {
      return item ? item.split(/\s+/) : [""];
    }).reduce(function (prev, next) {
      return prev.concat(next);
    }, []).filter(function (v) {
      return !!v;
    }).reduce(function (prev, next) {
      return prev.filter(function (v) {
        return v != next;
      }).concat(next);
    }, []);
    return cnl.join(' ');
  }
};
var _default = ClassList;
exports.default = _default;